// extracted by mini-css-extract-plugin
module.exports = {"watermark":"Watermark_watermark_3iTo1","poweredBy":"Watermark_poweredBy_3h-x_","bottomRight":"Watermark_bottomRight_3Uegy","bottomLeft":"Watermark_bottomLeft_34pWd"};